import { authFetch } from 'src/auth/utils';
import { ChartTypeValue } from 'src/common/components/ChartTypeToggle/ChartTypeToggle';
import { UsageTypeValue } from 'src/common/components/UsageTypeSwitch/UsageTypeSwitch';
import { envVariables } from 'src/common/utils/envVariables';
import { UsageDto } from 'src/common/utils/mapUsageDTOtoAreaChartData';
import { DoughnutDTO } from 'src/common/components/Dashboard/Types/DashboardApiTypes';
import { ObjectValues } from 'src/common/tsHelpers';

export const PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS = {
  TEST: 'Test',
  ACTIVE: 'Active',
  DEACTIVATED: 'Deactivated',
} as const;

type ProductsSummarySubscriptionStatus = ObjectValues<typeof PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS>;

type GetProductSummarySubscriptionStatusProps = {
  tariffCode?: string | null;
};

export const getProductSummarySubscriptionStatus = async (
  { tariffCode }: GetProductSummarySubscriptionStatusProps,
  signal?: AbortSignal,
) => {
  const productsSummarySubscriptionStatusResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage-tracking/tariffs/pie-chart${
      tariffCode ? `?tariffCode=${tariffCode}` : ''
    }`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const productsSummarySubscriptionStatusDTO: DoughnutDTO<ProductsSummarySubscriptionStatus> =
    await productsSummarySubscriptionStatusResponse.json();

  const data = productsSummarySubscriptionStatusDTO.data.reduce(
    (acc, entry) => {
      acc[entry.label] = entry.value;
      return acc;
    },
    {
      [PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.ACTIVE]: 0,
      [PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.TEST]: 0,
      [PRODUCTS_SUMMARY_SUBSCRIPTION_STATUS.DEACTIVATED]: 0,
    },
  );

  return { data, total: productsSummarySubscriptionStatusDTO.total };
};

type GetProductSummaryCumulativeUsageProps = {
  productCode: string;
  chartType: ChartTypeValue;
  usageType: UsageTypeValue;
};

export const getProductSummaryCumulativeUsage = async (
  { productCode, chartType, usageType }: GetProductSummaryCumulativeUsageProps,
  signal?: AbortSignal,
) => {
  const productSummaryCumulativeUsageResponse = await authFetch(
    `${envVariables.VITE_ANALYTICS_MODULE_URL}/usage-tracking/tariff-usage/${productCode}/installer/daily/${chartType}/${usageType}/linechart`,
    {
      signal,
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  const productSummaryCumulativeUsageDTO: UsageDto =
    await productSummaryCumulativeUsageResponse.json();

  return productSummaryCumulativeUsageDTO.chartData;
};
